import http from '../../../Utils/http';

const GetCandidates = {
  name: 'signJetSyncCandidates',
  state: {
    loading: false,
    error: '',
    data: [],
  },
  reducers: {
    CandidatesRequested(state) {
      return { ...state, loading: true, error: '' };
    },
    CandidatesReceived(state, payload) {
      return {
        ...state,
        loading: false,
        error: '',
        data: Array.isArray(payload?.data?.candidates) ? payload.data.candidates : [],
      };
    },
    CandidatesRequestFailed(state, payload) {
      return { ...state, loading: false, error: payload, data: [] };
    },
    CandidatesClear(state) {
      return { ...state, loading: false, error: '', data: [] };
    },
  },
  effects: (dispatch) => ({
    async requestForCandidates({ entityId, search }) {
      try {
        this.CandidatesRequested();
        const params = new URLSearchParams();
        if (search) params.append('search', search);

        const response = await http.get(
          `savvy/signjet-sync/entities/${entityId}/candidates?${params.toString()}`
        );
        this.CandidatesReceived(response.data);
      } catch (err) {
        const message = err?.response?.data?.error || err?.message || 'Unknown error';
        this.CandidatesRequestFailed(message);
        dispatch({
          type: 'helper/show',
          payload: { type: 'error', data: 'Failed to load candidates', open: true },
        });
      }
    },
  }),
};

export default GetCandidates;
